import '@mui/x-charts-pro/themeAugmentation'
import { Components, Theme } from '@mui/material'

// Chart chrome for every x-charts chart, kept in the design system so feature code never reaches into MUI X
// internal classes. ChartsAxis exposes only a `root` slot, so its line / tick / tick-label are reached through
// nested selectors; ChartsGrid exposes a `line` slot directly.
export const MuiChartsAxis: Components<Omit<Theme, 'components'>>['MuiChartsAxis'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiChartsAxis-line': { stroke: theme.palette.border.subtle },
      '& .MuiChartsAxis-tick': { stroke: theme.palette.border.subtle },
      '& .MuiChartsAxis-tickLabel': { fill: theme.palette.fg.muted },
    }),
  },
}

export const MuiChartsGrid: Components<Omit<Theme, 'components'>>['MuiChartsGrid'] = {
  styleOverrides: {
    line: ({ theme }) => ({ stroke: theme.palette.border.subtle, strokeOpacity: 0.5 }),
  },
}
